import { Suspense } from 'react';

import conversionIcon from '@/image/conversionIcon.svg';
import mobilityIcon from '@/image/mobilityIcon.svg';
import Layout from '@/Layout';
import Home from '@/page/home';
import LpInfo from '@/page/LpInfo';
import Mobility from '@/page/mobility';
import MyLp from '@/page/myLp';

import { RouterGuard } from './RouteGuard';

export const routeConfig = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Home />,   // tab 首页
        header: true, // 是否显示头部
        foot: true, // 是否显示底部
        icon: conversionIcon, // tab 图标
        footTitle: 'swap', // tab 标题
        headerTitle: 'swap', // 页面标题
      },
      {
        path: "/mobility",
        element: <Mobility />,   // tab 质押挖矿
        header: true, // 是否显示头部
        foot: true, // 是否显示底部
        icon: mobilityIcon, // tab 图标
        footTitle: 'liquidity', // tab 标题
        headerTitle: 'addLiquidity', // 页面标题
      }, {
        path: "/myLp",
        element: <MyLp />,
        header: false, // 是否显示头部
        foot: false, // 是否显示底部
        icon: '', // tab 图标
        footTitle: '', // tab 标题
        headerTitle: '', // 页面标题
      }, {
        path: "/lpInfo",
        element: <LpInfo />,
        header: false, // 是否显示头部
        foot: false, // 是否显示底部
        icon: '', // tab 图标
        footTitle: '', // tab 标题
        headerTitle: '', // 页面标题
      }
    ],
  },
];

const AppRouter = () => {
  const element = RouterGuard(routeConfig);
  return <Suspense> {element}</Suspense>;
};
export default AppRouter;
